export default "__VITE_ASSET__C1XSunP$__"